export const trackEvent = (name, parentName = "") => {
  const data = {
    event_navigation_name: name,
    event_navigation_action: "navigation",
    event_navigation_browsing_method: "click",
    ...(parentName ? { article_parent_name: parentName } : {}),
  };
  window.utag.link(data);
};

export const bookNowTealium = () => {
  trackEvent("button:book now");
};

export const browseParksTealium = () => {
  trackEvent("button:browse parks");
};

export const howItWorksTealium = () => {
  trackEvent("button:how it works");
};

export const homepageCTATealium = (buttonName, tileName) => {
  trackEvent(`tile button:${buttonName}`, tileName);
};

export const parksFilterTealium = (filterType, filterValue) => {
  const byFilter = `by ${filterType}`;
  trackEvent(`browse parks:filter:${byFilter}`, `${byFilter}:${filterValue}`);
};

export const parksRemoveFilterTealium = (filterValue) => {
  trackEvent("browse parks:filter:cleared", filterValue);
};

export const parksRemoveAllFiltersTealium = () => {
  trackEvent("browse parks:filter:reset filters");
};

export const viewParkTealium = (parkName) => {
  trackEvent("browse parks:button:view park info", parkName);
};
